import { Users, Briefcase, Settings, PieChart, FileText, UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
export const AdminQuickLinks = () => {
  const navigate = useNavigate();
  const quickLinks = [{
    title: "Clients",
    description: "View and manage all clients",
    icon: Users,
    path: "/admin/clients",
    color: "bg-blue-50 text-blue-700 border-blue-200"
  }, {
    title: "Add Client",
    description: "Create a new client account",
    icon: UserPlus,
    path: "/admin/new-client",
    color: "bg-green-50 text-green-700 border-green-200"
  }, {
    title: "Employees",
    description: "Manage staff and producers",
    icon: Briefcase,
    path: "/admin/employees",
    color: "bg-purple-50 text-purple-700 border-purple-200"
  }, {
    title: "Sales Dashboard",
    description: "View sales metrics and reports",
    icon: PieChart,
    path: "/admin/sales",
    color: "bg-amber-50 text-amber-700 border-amber-200"
  }, {
    title: "Leads",
    description: "View and manage leads",
    icon: FileText,
    path: "/admin/leads",
    color: "bg-indigo-50 text-indigo-700 border-indigo-200"
  }, {
    title: "Admin Settings",
    description: "Configure system fields and options",
    icon: Settings,
    path: "/admin/fields",
    color: "bg-slate-50 text-slate-700 border-slate-200"
  }];
  return <div className="mb-8">
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {quickLinks.map(link => <button key={link.title} onClick={() => navigate(link.path)} className={`p-4 rounded-lg border flex items-start text-left transition-all hover:shadow-md ${link.color}`}>
            <div className="mr-4 mt-1">
              <link.icon className="h-5 w-5" />
            </div>
            <div>
              <h3 className="font-medium">{link.title}</h3>
              <p className="text-sm opacity-75">{link.description}</p>
            </div>
          </button>)}
      </div>
    </div>;
};